<script setup>
import { ref, watch, defineProps, defineEmits, onMounted } from 'vue';

const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    placeholder: {
        type: String,
        default: '',
    },
    defaultValue: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['toggle']);
const model = defineModel();

function handleToggle() {
    if (props.disabled) return;
    model.value = !model.value;
    emit('toggle', model.value);
}
</script>

<template>
    <div class="switch-input">
        <label v-if="props.label" class="switch-input__label">
            {{ props.label }}
        </label>

        <div class="switch-input__form" @click="handleToggle">
            <div class="switch-input__switcher" :class="{ 'active': model }">
                <div class="switch-input__switcher--toggle"></div>
            </div>
            <span v-if="props.placeholder" class="switch-input__placeholder">
                {{ props.placeholder }}
            </span>
        </div>
    </div>
</template>

<style lang="scss">
.switch-input {
    position: relative;

    &__label {
        font-size: 14px;
        color: #000000;
        margin-bottom: .5rem;
        display: inline-block;
    }

    &__placeholder {
        font-size: 14px;
        color: #000000;
        cursor: pointer;
    }

    &__form {
        display: flex;
        align-items: center;
    }

    &__switcher {
        width: 60px;
        height: 30px;
        border-radius: 8px;
        border: 2px solid #7DD3FC;
        margin-right: 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 .1rem;
        cursor: pointer;
        transition: .2s;

        &--toggle {
            border: 2px solid #7DD3FC;
            width: 30px;
            height: 24px;
            border-radius: 5px;
            background: #ffffff;
            transition: .2s;
        }
    }

    &__switcher.active {
        justify-content: flex-end;

        .switch-input__switcher--toggle {
            background: #7DD3FC;
        }
    }
}
</style>
